import { Dispatch, SetStateAction } from "react";
import {
  CertificateRegistryApiTypes,
  bulkSignOrchestratorApi,
  certificateRegistryApi,
} from "@rshbintech.dboul/http";

import {
  CANCEL_CONFIRM_WINDOW_BY_USER_ANNOTATION,
  CUSTOM_ERROR_KEYS,
  SIGNING_STATUSES,
  UNKNOWN_ERROR,
} from "../constants";
import { checkSignPossibility } from "./check-sign-possibility";
import { isErrorEvent } from "./is-error-event";
import { isErrorInfo } from "./is-error-info";
import { chooseValidCertificate } from "./choose-valid-certificate";

export const getStartSigning = (
  taskId: string,
  setIsReturnButtonVisible: Dispatch<SetStateAction<boolean>>,
  setStatus: Dispatch<SetStateAction<SIGNING_STATUSES>>,
  setError: Dispatch<SetStateAction<string>>,
  setCertificate: Dispatch<
    SetStateAction<CertificateRegistryApiTypes.ShortCertInfo | undefined>
  >
) => {
  const startSigning = async () => {
    try {
      const userCertificates = (
        await certificateRegistryApi.api.getUserCertificates()
      ).data;

      const validCertificate = chooseValidCertificate(userCertificates);

      await checkSignPossibility(validCertificate); // провeряем возможность подписания
      await bulkSignOrchestratorApi.api.setCertificate(
        taskId,
        validCertificate
      );

      await bulkSignOrchestratorApi.api.startSignTask(taskId);

      setIsReturnButtonVisible(false);
      setStatus(SIGNING_STATUSES.IS_SIGNING); // запустит useEffect, который проведет по шагам подписание
      setCertificate(validCertificate);
    } catch (error) {
      // на этом этапе нельзя использовать утилиту processError, так как
      // нужно сохранить возможность продолжить подписание
      const errorData = isErrorEvent(error) ? error.error : error;

      if (isErrorInfo(errorData)) {
        setError(errorData.message);
      } else if (error && typeof error === "string") {
        // если не ошибка пинкода или загрузки плагина
        // надо оставить возможность исправить и начать подписание
        if (error === CANCEL_CONFIRM_WINDOW_BY_USER_ANNOTATION) {
          setError(error);
        }

        if (
          error !== CUSTOM_ERROR_KEYS.INVALID_PINCODE &&
          error !== CUSTOM_ERROR_KEYS.CRYPTO_PLUGIN_IS_INACTIVE
        ) {
          setStatus(SIGNING_STATUSES.SIGNING_STOPPED);
        } else {
          setError(error);
        }
      } else {
        setError(UNKNOWN_ERROR);
      }
    }
  };

  return { startSigning };
};
